module.exports = __webpack_public_path__ + "static/media/left-bannerv2.ebbc0816.png";